// Utils
import { generateID } from "utils";

// TypesBC
import { BCGraph } from "services";
import { TBCSectionData } from "..";

/**
 * Transform OVERALL or AVERAGES data to be used by LD12Chart
 *
 * @param {BCGraph} data
 * @returns {(TBCSectionData | undefined)}
 */
export const convertAverageData = (data: BCGraph): TBCSectionData | undefined => {
    if (!data.data_series?.distributions || !data.data_series?.distribution_y) return;
    const isHubAverage = data.id.toLowerCase().includes("overall");

    // Find MEAN index in distribution_y
    const averageDistributionY = data.data_series.distribution_y;
    const idToFind = "MEAN";
    const medianIndex = averageDistributionY?.findIndex((d) => d.id === idToFind) || 0;

    // Convert data_series.distributions to array
    const averageSeriesArr = Object.entries(data.data_series.distributions);

    // Loop the array of entries and keep the id and the median value: [["0", 6], ["1", 3]]
    const averageMedianSeries = averageSeriesArr.map((el) => [el[0], el[1][medianIndex]]);

    // Convert to an object: {"0": 6, "1": 3}
    const series: Record<string, number | null> = Object.fromEntries(averageMedianSeries);

    const convertedLabel = data.id.split(".")?.[1]?.replaceAll("_", " ");
    const label = isHubAverage ? "Hub Average" : convertedLabel;

    return {
        id: data.id,
        label,
        company_name: "",
        entity_type: "company",
        entity_id: generateID(),
        entity_name: label,
        has_real_pace: true,
        show_real_pace: true,
        series,
    };
};
